import { jsxs, jsx } from 'react/jsx-runtime';
import { Icon } from '../components/internal/Icon.js';

function WarningIcon(props) {
  return /* @__PURE__ */ jsxs(Icon, {
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", {
        d: "m3.794 13.526 5.326-9.89a1 1 0 0 1 1.76 0l5.326 9.89a1 1 0 0 1-.88 1.474H4.674a1 1 0 0 1-.88-1.474ZM10 7.5v2m0 2.5h.007"
      }),
      /* @__PURE__ */ jsx("circle", {
        cx: 10,
        cy: 12,
        r: 0.25
      })
    ]
  });
}

export { WarningIcon };
//# sourceMappingURL=Warning.js.map
